import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from '../../../../components/Input';
import MaterialSelector from '../../../../components/MaterialSelector';
import {
  setWoodConnectionType,
  setProfileMaterial,
  setProfileFamily,
  setProfileSize
} from '../../../../reducers/selectors/application/actions';
import { APP_TYPES, defaultUnits } from '@config';
import { APP_TEXTS } from '@texts';
import './styles.scss';
import Scene from '@scene';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { setObjectType } from '@reducers/options/actions';
import { Tooltip } from '@components/Tippy';
import { getTooltip } from '@tooltips';
import { setAxisOrientation, setPerspectiveCamera } from '@reducers/camera/actions';
import { unitTransform } from '@services/helper.service';

class WoodConnection extends Component {

  handleTypeChange = (index) => {
    this.props.setWoodConnectionType(index);
  };

  handleMaterialChange = (event) => {
    this.props.setWoodConnectionMaterial(event.target.value);
  };

  handleWoodPanelChange = (field, value) => {
    const newOptions = {
      wood: {
        ...this.props.woodPanel,
        [field]: Number(value)
      }
    };
    this.props.setPanelOptions(newOptions);
  };

  render() {
    const { woodPanel, woodConnectionTypes, selectedTypeId, profileMaterial } = this.props;
    return (
      <div className="list-type">
        <div className="mb-3">
          <div id="type-label" className="font-weight-bold mb-2">{APP_TEXTS.TYPE_LABEL.Content}</div>
          <ul className="inline-list">
            {woodConnectionTypes.map((type, index) => (
              <li key={type.id}>
                <Tooltip key={type.id} content={getTooltip(type.tooltip)}>
                  <button
                    key={type.id}
                    className={`btn btn-light ${selectedTypeId === type.id && 'ImageButton--active'}`}
                    onClick={() => this.handleTypeChange(type)}
                  >
                    <img
                      src={type.icon}
                      alt={`Wood Connection Type ${index + 1}`}
                      className="type-image object-fit-contain"
                    />
                  </button>
                </Tooltip>
              </li>
            ))}
          </ul>
        </div>

        <div className="mb-3">
          <MaterialSelector
            material={profileMaterial}
            onMaterialSelect={this.props.onProfileMaterialSelect}
          />
        </div>

        <div className='d-flex gap-3'>
          <div className="mb-3 mr-5">
            <h3 className="font-weight-bold mb-2">{APP_TEXTS.WOOD_CONNECTION_PANEL.Content}</h3>
            <div className="mb-2">
              <Input
                id="T"
                type="number"
                prefix={`${APP_TEXTS.WOOD_CONNECTION_CROSS_SECTION.Content} T =`}
                postfix={this.props.distanceUnit}
                value={unitTransform(woodPanel.T).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                onUpdate={value => this.handleWoodPanelChange(
                  'T', 
                  unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                )}
              />
              <Input
                id="L"
                type="number"
                prefix={` x L =`}
                postfix={this.props.distanceUnit}
                className="preserve-spaces"
                value={unitTransform(woodPanel.L).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                onUpdate={value => this.handleWoodPanelChange(
                  'L', 
                  unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                )}
              />
            </div>
            <div className="mb-2">
              <Input
                id="thickness-e1"
                type="number"
                prefix={selectedTypeId === 0 ? 
                  APP_TEXTS.WOOD_CONNECTION_THICKNESS_E2.Content : APP_TEXTS.WOOD_CONNECTION_THICKNESS_E1.Content
                }
                postfix={this.props.distanceUnit}
                value={unitTransform(woodPanel.thicknessE1).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                onUpdate={value => this.handleWoodPanelChange(
                  'thicknessE1', 
                  unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                )}
              />
            </div>
            {selectedTypeId !== 0 && (
              <div>
                <Input
                  id="thickness-e2"
                  type="number"
                  prefix={APP_TEXTS.WOOD_CONNECTION_THICKNESS_E2.Content}
                  postfix={this.props.distanceUnit}
                  value={unitTransform(woodPanel.thicknessE2).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                  onUpdate={value => this.handleWoodPanelChange(
                    'thicknessE2', 
                    unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                  )}
                />
              </div>
            )}
          </div>

          <div className="mt-3">
            <img
              src={woodPanel.image}
              className='wood-panel-image img-fluid'
              alt="Static barrier diagram"
            />
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => ({
  woodPanel: state.selectors.application[APP_TYPES.WOOD_CONNECTION].woodPanel,
  woodConnectionTypes: state.selectors.application[APP_TYPES.WOOD_CONNECTION].woodConnectionTypes,
  selectedTypeId: state.selectors.application[APP_TYPES.WOOD_CONNECTION].selectedTypeId,
  profileMaterial: state.selectors.application[APP_TYPES.WOOD_CONNECTION].profile.material,
  profileFamily: state.selectors.application[APP_TYPES.WOOD_CONNECTION].profile.family,
  profileSize: state.selectors.application[APP_TYPES.WOOD_CONNECTION].profile.size,
  distanceUnit: state.main.units.distance
});

const mapDispatchToProps = dispatch => ({
  setPanelOptions: (options) => dispatch(setPanelOptions(options)),
  setWoodConnectionType: (type) => {
    dispatch(setObjectType(type.id));
    dispatch(setWoodConnectionType(type.id));
    dispatch(setPanelOptions({ wood: { ...type.woodPanel } }));
    dispatch(setPerspectiveCamera(type.perspectiveCamera));
    dispatch(setAxisOrientation(type.orientation));
    // VP: for now we reset the camera after all the above dispatches were finished, 
    // in the future we will set the camera to a certain perspective and at that point we can reset camera
    setTimeout(() => Scene.resetCamera(), 50);
  },
  onProfileMaterialSelect: value => dispatch(setProfileMaterial(value)),
  onProfileFamilySelect: value => dispatch(setProfileFamily(value)),
  onProfileSizeSelect: value => dispatch(setProfileSize(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WoodConnection);



// WEBPACK FOOTER //
// ./src/views/Application/types/WoodConnection/WoodConnection.js